(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meriphora-creator-all-products"] && !Shopify.designMode) return;
  try {
    
  function sortCreatorProducts(resultsList, sortBy) {
    const grid = resultsList.querySelector('[data-testid="product-grid"]');
    if (!grid) return;

    const items = Array.from(grid.querySelectorAll('.product-grid__item'));
    const compareText = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
    const numericValue = (item, attribute) => Number(item.dataset[attribute] || 0);

    items.sort((first, second) => {
      switch (sortBy) {
        case 'price-ascending':
          return numericValue(first, 'creatorSortPrice') - numericValue(second, 'creatorSortPrice');
        case 'price-descending':
          return numericValue(second, 'creatorSortPrice') - numericValue(first, 'creatorSortPrice');
        case 'title-ascending':
          return compareText.compare(first.dataset.creatorSortTitle || '', second.dataset.creatorSortTitle || '');
        case 'title-descending':
          return compareText.compare(second.dataset.creatorSortTitle || '', first.dataset.creatorSortTitle || '');
        case 'created-ascending':
          return numericValue(first, 'creatorSortCreatedAt') - numericValue(second, 'creatorSortCreatedAt');
        case 'created-descending':
          return numericValue(second, 'creatorSortCreatedAt') - numericValue(first, 'creatorSortCreatedAt');
        default:
          return numericValue(first, 'creatorSortIndex') - numericValue(second, 'creatorSortIndex');
      }
    });

    grid.append(...items);
  }

  function syncCreatorSortControls(resultsList, sortBy) {
    resultsList.querySelectorAll('[name="sort_by"]').forEach((control) => {
      if (control instanceof HTMLSelectElement) {
        control.value = sortBy;
      } else if (control instanceof HTMLInputElement) {
        control.checked = control.value === sortBy;
      }
    });
  }

  function updateCreatorSort(resultsList, sortBy, pushState = false) {
    const selectedSort = sortBy || 'manual';
    syncCreatorSortControls(resultsList, selectedSort);
    sortCreatorProducts(resultsList, selectedSort);

    const url = new URL(window.location.href);
    if (selectedSort === 'manual') {
      url.searchParams.delete('sort_by');
    } else {
      url.searchParams.set('sort_by', selectedSort);
    }

    if (pushState) {
      window.history.pushState({}, '', url.toString());
    }
  }

  function initializeCreatorCollection(resultsList) {
    if (resultsList.dataset.creatorCollectionInitialized === 'true') return;
    resultsList.dataset.creatorCollectionInitialized = 'true';

    resultsList.querySelectorAll('sorting-filter-component').forEach((component) => {
      component.removeAttribute('on:change');
    });

    const initialSort = new URL(window.location.href).searchParams.get('sort_by') || 'manual';
    updateCreatorSort(resultsList, initialSort);

    resultsList.addEventListener(
      'change',
      (event) => {
        const control = event.target;
        if (!(control instanceof HTMLInputElement || control instanceof HTMLSelectElement)) return;
        if (control.name !== 'sort_by') return;

        event.stopImmediatePropagation();
        updateCreatorSort(resultsList, control.value, true);
      },
      true
    );

    window.addEventListener('popstate', () => {
      const sortBy = new URL(window.location.href).searchParams.get('sort_by') || 'manual';
      updateCreatorSort(resultsList, sortBy);
    });
  }

  document.querySelectorAll('[data-meriphora-creator-all-products]').forEach(initializeCreatorCollection);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll?.('[data-meriphora-creator-all-products]').forEach(initializeCreatorCollection);
  });

  } catch(e) { console.error(e); }
})();
})();
